import {ApolloQueryResult} from 'apollo-client/core/types';
import {DocumentNode} from 'graphql';

import {apolloClient} from '../../../apolloClient';
import {propagateErrorsContext} from '../../../util/errors';
import {TileMediaSpec} from '../../MediaCard';
import {getKeyForRunSignature, RunSignatureKey} from './keys';

type FetchGQLParams<V> = {
  query: DocumentNode;
  variables: V;
};

export async function fetchGQL<Variables, Data>({
  query,
  variables,
}: FetchGQLParams<Variables>): Promise<Data | null> {
  try {
    const gqlResponse: ApolloQueryResult<Data> = await apolloClient.query({
      query,
      variables,
      fetchPolicy: 'no-cache',
      context: propagateErrorsContext(),
    });
    if (gqlResponse.errors != null) {
      throw gqlResponse.errors;
    }
    return gqlResponse.data ?? null;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export function groupTileMediaSpecsByRunSignatureKey(
  tileMediaSpecs: TileMediaSpec[]
) {
  const result: Map<RunSignatureKey, TileMediaSpec[]> = new Map();
  for (const tileMediaSpec of tileMediaSpecs) {
    const runSignatureKey = getKeyForRunSignature(tileMediaSpec.runSignature);
    const tileMediaSpecsForRun = result.get(runSignatureKey) ?? [];
    tileMediaSpecsForRun.push(tileMediaSpec);
    result.set(runSignatureKey, tileMediaSpecsForRun);
  }
  return result;
}
